import { View } from "react-native";
import CapsuleButton from "@components/CapsuleButton";
import { Filter } from "./types";

const AnimatedFilterButton = ({
  config,
  filter,
  onPress,
}: {
  config: {
    value: Filter;
    title: string;
    sentryEventName: string;
  };
  filter: Filter | null;
  onPress: () => void;
}) => {
  const isSelected = filter === config.value;

  return (
    <View style={{ zIndex: isSelected ? 10 : 1 }}>
      <CapsuleButton
        sentryEventName={config.sentryEventName}
        isSelected={isSelected}
        onPress={onPress}
        title={config.title}
        accessibilityLabel={`${config.title}, library category`}
        accessibilityHint="Activate to filter your library. Scroll horizontally to browse more categories."
        accessibilityState={{ selected: isSelected }}
      />
    </View>
  );
};

export default AnimatedFilterButton;
